// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { MobService_abstract } from './../abstract/SagaSchema/MobService_abstract';
export class MobService extends MobService_abstract {}
